export default __webpack_public_path__ + "static/media/airdockz-bpk-3.9c3d765c.png";